import {useRouter} from 'next/router';
import {WebPageJsonLd} from 'next-seo';
import {getCurrentUrl} from '@app/modules/location';
import type {FunctionComponent} from 'react';

type WebpageStructuredDataProps = {
	description: string;
};

export const WebpageStructuredData: FunctionComponent<
	WebpageStructuredDataProps
> = ({description}) => {
	const {locale, asPath} = useRouter();
	const lastPath =
		asPath
			.split('/')
			.filter((path) => path)
			.pop() || '';

	return (
		<WebPageJsonLd
			id={`${getCurrentUrl({locale, pathname: asPath})}#webpage`}
			name={lastPath[0].toUpperCase() + lastPath.slice(1, lastPath.length)} // Capitalize path element as name. We will need to change this to use a translation for each page name (not available right now).
			url={getCurrentUrl({locale, pathname: asPath})}
			description={description}
			isPartOf="https://www.deezer.com/#website"
			publisher="https://www.deezer.com/#organization"
		/>
	);
};
